// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginBox_container__38VF-","formContainer":"LoginBox_formContainer__ZF22Y"};